module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After two weeks of steady work, Orient managed to put together the first ten minutes of what he hoped would be a thirty-minute visual demonstration of his work in telepathy with Sybelle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As he went through the tedious hand process of marking the tape, cutting and splicing, he thought of the CBS Automatic Editor he once planned to add to the studio. Just mark the special screen with an electronic pencil and the computer does the rest. Handy but very expensive, and there was other lab equipment more crucially needed:")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had cut a full twenty-one minutes of the film by the time Sybelle called to tell him SEE had agreed to consider his project. “In two weeks,” she told him breathlessly. “Isn’t it marvelous?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Great.” Orient cradled the phone between his neck and shoulder as he spoke, hands moving restlessly over the strips of tape on his worktable. “Should have our visual finished by then, with luck.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, of course you must. This is your chance to educate the public darling. They’re going to be astounded.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Have you been keeping up your routine?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Like a drudge. And my powers have never been keener.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who else is competing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just some sort of girl prophet. But that’s old hat. "), _c('i', [_vm._v("I’ve ")]), _vm._v("been known to have my moments myself. The conscious transmission of thoughts is something new. I’m positive we’ll absolutely stop them dead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient laughed. “Going to need "), _c('i', [_vm._v("your ")]), _vm._v("help to do them in, so keep on your diet. Anything else I have to do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, I don’t think so. The conference lasts for a few days. They’re supplying the tickets so you won’t have to worry about that end, and—there was something else— "), _c('i', [_vm._v("oh ")]), _vm._v("yes, bring lots of warm clothes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How come? It’s only September.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle giggled. “Didn’t you know darling? Carl Bestman lives in Sweden. That’s where we meet every year. It gets very cold, very early. Better bring long Johns.” She giggled: again and hung up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient’s luck proved to be running lame during the next couple of weeks. He was plagued with underexposed images, overheated power packs, inferior skills, and an increasing desire to forget the whole thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("An hour and a half before he was due to meet Sybelle at the airport, he found himself still running the last three minutes through the screener. Sordi stood behind him, alternately checking his watch and giving last-minute instructions. “I packed the cashmere blazer and a couple of extra sweaters; I left the leather trench coat out. You’ll need it when you reach Stockholm.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay, thanks,” Orient murmured, intent on the screen images. “Do you like the close-up of Sybelle here, or do you think I should splice in a medium shot?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sordi glanced at his watch. “Keep the close-up. It’s more personal. The tux is packed, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient’s attention was still distracted as he began winding the tape. “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Your tuxedo. It’s right on top. Hang it up right away when you get there,” Sordi explained.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What makes you think I’ll need a tuxedo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sure you will, when you win the prize.” He waved away Orient’s protests and pointed at his watch. “Don’t worry about anything. Just make your speech and collect the money. Go get your coat. I’ll finish packing this stuff. We don’t have much time. We still have to pick up Sybelle.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When the Ghost pulled up to Sybelle’s brownstone Orient saw her sitting in front, on the sidewalk. She was perched on the largest of four pastel green suitcases that matched the color of her Laurent lapelled, shantung pantsuit. She waved and picked up a hooded, red fox fur coat that complimented the orange highlights in her hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We’re late,” she called, as Orient and Sordi started loading the bags into the trunk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t worry. We’ll make it.” Sordi held the door open for her. “You look great Sybelle.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Why, thank you.” She smiled and lowered her lashes, silently grateful that the Rolls’ large door made a graceful entrance possible. She began to appreciate Owen’s fondness for the vintage car.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was bubbling with anticipation as Sordi sped along the East River Drive toward Kennedy airport. “It’s going to be a fascinating trip, darling,” she told him. “You’ll meet the biggest names in the psychic field.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Looking forward to it,” Orient grunted. He was stretching the truth. Groups, gatherings, and academies made him uneasy. He preferred to work alone and avoid the inevitable politics. He took a silver case from the pocket of his coat and looked at the oval design on its surface. The swirling figure was his Mandala, his meditation scroll The case had been given to him by the master Ku many years ago in Tibet. It was a sign that the time had come for him to return to the cities after months on the mountain. It was also a reminder that he had to take part in the affairs of his time to fulfill his destiny. Orient opened the case and extracted a hand-wrapped cigarette. He looked at Sybelle. “Smoke?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She made a face. “You know I hate the way those things smell.” She took an envelope from her purse and fanned herself vigorously as Orient struck a match and the pungent odor wafted back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient reached over and pressed a switch. A small exhaust fan near Sybelle quickly cleared the air in the car.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What a good thing to have,” Sybelle said approvingly. “This museum piece of yours has its advantages.” She handed the envelope she was holding to him. “The tickets. We connect to a train when we reach Stockholm. Carl will pick us up at the station. You’ll love it. His place is so beautiful and secluded. A marvelous place for our meetings.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient nodded. “What happens during the meetings?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We discuss various ventures the members bring up, examine new findings, bring up projects. Carl’s donated a lot of money to setting up a library in Amsterdam.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle stretched out her legs. “We all contribute. A wonderful project. The first library of psychic science.” And then, of course, after the meetings, we judge the merits of the applicants.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you one of the judges?” Sordi inquired hopefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She smiled prettily into the rear-view mirror. “Not for Owen. It wouldn’t be fair. I’ll sit it out. But he won’t need my vote.” She patted Orient’s shoulder. “His research is a real breakthrough. Carl will probably want some notes for the library.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll give him a copy of the tape,” Orient said, staring at the burning tip of his cigarette. “And that’s it? No other business at the conference?” He looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle wavered under the steadiness of his wide green eyes. “Well,” she smiled nervously and sat back, “of "), _c('i', [_vm._v("course ")]), _vm._v("there’s the séance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She glanced at the back of Sordi’s head and lowered her voice. “Carl is very interested in contacting the dead. I usually assist. We all do.” Orient nodded, vaguely uneasy at the prospect.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now I don’t have to be a mind reader to catch "), _c('i', [_vm._v("that ")]), _vm._v("stern look of disapproval,” Sybelle chided. “Don’t be such a purist darling.” She pouted at him. “I would have told you sooner, but then I’d have to sit through one of your dreary lectures about caution. And you’d probably have made a fuss about coming.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient smiled. “No fuss unless your chums try to pay us off in ectoplasm instead of cash.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s the spirit,” Sordi said dryly. “Make your speech and collect the money.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I must say your attitude is marvelously festive; pity there isn’t anything in this fancy car for a pre night celebration.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just pull the handle in front of you,” Orient told her. “Glasses, ice, soda, and Scotch. Sordi restocked it specially for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How "), _c('i', [_vm._v("thoughtful. ")]), _vm._v("When we get back, we’ll have to have a nice dinner. Just the three of us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A victory dinner,” Sordi said. “And I’ll cook.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient said something, but Sybelle wasn’t listening. She was absorbed in calculating what she would wear when she next saw Sordi.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle decided to stay with Scotch on the plane. After an hour of flight and three more drinks, she was ready to spend the next eight hours talking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient kept her busy for a while, reviewing the procedures they would go through. “We’ll screen a thirty-minute documentary then finish with a live demonstration,” he explained. “Think you’ll be able to communicate in front of an audience?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I always have before darling,” Sybelle winked. “We’ll floor them. It’s just the kind or thing Carl’s been looking for. Proof of your telepathic technique will finally justify his fight to keep SEE going.” She held up her empty glass as the stewardess passed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Two more,” Orient said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Doubles,” Sybelle corrected. She leaned back in her chair and closed her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Did Carl Bestman have much trouble organizing SEE?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle opened one violet-shaded eye. “His brother,” she whispered, “hates SEE. He even tried to get a court order to take over Carl’s estate. But Carl had it thrown out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It did seem strange that Anthony Bestman wouldn’t normally refer me to his brother.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle smiled grimly. “He’s like that. I met him once and he was terribly rude. Count Germaine told him to his face that a true sportsman never killed except for food, and never insulted a lady.” She took a mirror from her purse and hastily checked her make-up and curly halo of bright red hair. “European men are so gallant— like your friend.” She put the mirror away and leaned closer. “About how old is Sordi?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient grinned. “Any special reason?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course not. It’s just that he reminds me of the count: distinguished and very kind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who is this count?” Orient asked, avoiding her question.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She sighed. “He’s a lovely man. Count Germaine is the leading member of our board. A remarkably gifted hypnotist. Very tall. Stately. He’s the head of the library in Amsterdam. And so kind, so gallant.” Her reverie was interrupted by the arrival of the stewardess with the drinks. She plucked a glass from the tray and handed it to Orient.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The count "), _c('i', [_vm._v("devastated ")]), _vm._v("Anthony,” she said, relishing the moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Carl and Anthony seem to have a messy time of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, it was awful. For a long time. It was especially hard on Carl. He’s such a gentle soul. But after he lost the court suit Anthony went back to his silly big-game hunting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now that you mention it, that coat you’re sitting on looks like a big-game trophy,” Orient said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Damn right, darling.” Sybelle winked. “I begged a dear French furrier who was mad about me.” She patted the red coat draped over her chair. “Isn’t it marvelous? It’s the warmest thing I have. And it’s perfectly legal. It’s an antique that was made "), _c('i', [_vm._v("pre-ecology.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Seven hours later, when the plane landed at Arlanda, near Stockholm, Orient discovered that his own trench coat was poor protection against the sharp North wind cutting steadily through his clothing, Sybelle, wrapped to her pink ears in red fur, was ecstatic. All during the long cab ride into Stockholm, she continued to chatter. Orient half-listened and watched the scenery, grateful for the comparative warmth of the taxi. Sybelle’s words filtered through his thoughts as a splendid parade of trees, their gold and rust leaves brilliantly arrayed against the dark green foliage, flashed past his widow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maxwell is a dear. He’s a genius. Only twenty-one and he’s been a member of our board for three years. Marvelous boy. I’m sure the two of you will have a lot in common.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maxwell Andersen. You must have heard of him. He’s the British chess champion.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient half-closed his eyes. Sybelle’s enthusiastic drone set off a contagious air of well-being and he began thinking ahead to the details of their presentation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t you "), _c('i', [_vm._v("dare ")]), _vm._v("go to sleep,” she scolded after he failed to respond a few times. “We still have the whole train ride and I need company.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just going over the check list for the televised section.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you having it shipped?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s on the plane. In my suitcase.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But you only have two bags. Didn’t you bring "), _c('i', [_vm._v("anything ")]), _vm._v("to wear?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“All we need is the equipment in one suitcase. All portable-screener, laptop, and CD. Unless your friends are beyond electricity, we’re in good shape.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s lovely, dear,” Sybelle murmured. “Now do try to stay awake for a few hours longer. I detest traveling with no one to talk to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They reached Stockholm’s central station only thirty minutes before the departure time of their train. After checking their bags in their compartment, they decided to take a stroll around the station to unwind from their flight.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They wandered through a maze of food shops, boutiques, and restaurants thriving in the fluorescent light of the underground market. Sybelle bought a huge box of candied fruit. “For Carl’s wife,” she told Orient, “she loves them so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is she a member of SEE?” Orient asked as they walked back to the train.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, but Hannah understands Carl’s work; she’s his secretary. She doesn’t have a psychic gift, but she does have great faith. I’ve heard it said that Anthony wanted to marry her, but she was in love with Carl. She made a "), _c('i', [_vm._v("fabulous ")]), _vm._v("choice. Imagine having to tramp around in the jungle after a man who enjoys shooting helpless animals!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("What about your coat, Orient thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When they reached their compartment, Sybelle tucked her fur coat under her round chin and promptly fell asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient, now fully awake, was left to stare out at the approaching darkness as the train rolled out of Stockholm and headed North. A small seed of anticipation took root and flowered as he looked ahead to a busy week in the company of professional colleagues. As the hours passed, however, the sleepless grind dried up his optimism and anticipation eroded into impatience to reach Bestman’s home and find a bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle slept the entire six hours and when the train arrived at the small station marked "), _c('i', [_vm._v("Hudiksvall, ")]), _vm._v("Orient had to try three times before he succeeded in rousing her. He looked in vain for a porter and finally had to pass the six suitcases through the window to a still-bleary Sybelle on the platform, and then hurry off the train just as it started moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Okay, we’re here. Where’s Bestman?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle blinked and looked around. “See a big black Mercedes anywhere?” she mumbled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient pulled his collar up and jammed his hands into his pockets. The wind blew in gusts down from the dark hills behind the station and swept across the wide canal on the other side. The station house was a dimly lit, two-story building. It looked closed. Orient shivered as he waited for Sybelle to get her bearings.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Carl always sends his car,” Sybelle insisted. “Try the entrance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient walked around the unlit side of the building, moving slowly in the unfamiliar shadows. The blackness above him was crammed with thousands of stars, their hard sparkles competing with the velvet glow of a distant moon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stepped out of the darkness to the front. The station faced a single, deserted street. He took a few steps toward the streetlamp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was no car in sight along the narrow road that ran from the station entrance into the wind-swept darkness. A dog barked somewhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He heard the sound of an approaching motor, and he stood waiting in the light of the streetlamp, hopping from foot to foot, to keep his blood circulating in the numbing wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A pair of headlights beamed through the shadows, bobbing across the tangled branches of the trees lining the road.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The car wasn’t a Mercedes, but, to Orient’s relief, was an unoccupied Volvo taxi. He waved it to a stop and in a halting mixture of Swedish and English asked the driver to pull around to the side of the station.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After the bags had been fitted in the trunk and overhead rack, Orient crawled into the back seat. “We’re loaded. Now just tell our friend where to deliver us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle stared at the driver. “I don’t recall. Oh, dear. Does he know Bestman "), _c('i', [_vm._v("Herrgard?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver scowled at Orient and shook his head. “Nay. Nay Bestmon Herrgard.” He raced the motor impatiently.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I just can’t remember the address, but I’ve heard it many times before.” She bit her lip. “Sounds something like Weekhawken. I’m so bad with linguistics. "), _c('i', [_vm._v("North ")]), _vm._v("Weecoogan. I think that’s it.” She smiled brightly at the driver.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nord-vee-coo-gan?” she pronounced slowly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver shut the motor off and turned around to squint glumly at Sybelle. “Hey?” he said finally.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“North wee-cow-gen?” she ventured hopefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver shrugged. "), _c('i', [_vm._v("“Norbo-scoogarna, ")]), _vm._v("maybe,” was all he could suggest. He started the car and pulled away from the station.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The slow, steady throb of the motor was monotonous but reassuring as the taxi moved through the enclosing stillness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The car’s headlights only managed to pierce the blackness for a short distance before their glow was swallowed by the shadows at the edge of the road. They drove slowly through an immense stretch of forest on a road that seemed to be getting narrower with every mile.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Recognize any of this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Could be...” Sybelle said without conviction as she leaned forward to peer through the windshield. “Let’s wait to see where he takes us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient stared ahead into the night, trying to make out some crude signs of habitation. There was nothing except the empty road.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I hope he’s going "), _c('i', [_vm._v("somewhere” ")]), _vm._v("Sybelle grunted. “I have the exact address and phone number written down, but it’s packed. Carl is usually so prompt about sending the car. Perhaps he didn’t get my wire. Didn’t we send a wire from the train station?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient shook his head slowly. “No wire. All we did was buy a box of candied fruit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle brightened. “Oh yes, for Hannah. That explains it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Explains?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Why Carl didn’t send the car. We bought the candied fruit instead”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Right on.” Orient sat back and watched the lights drill forward through the tangled darkness. “I hope the driver sees it your way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, I’m sure,” Sybelle muttered. “It’s so lonely out here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A few minutes later the driver brought the car to a stop. He got out of the car and disappeared into the shadows, leaving the motor running. He came back a few moments later, took his post behind the wheel, and - without any word of explanation resumed driving through the brooding forest.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Did he stop to wee wee or get directions?” Sybelle whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Probably getting his bearings. Look.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle followed the direction of his finger and looked out the window. The wall of trees parted, revealing a. three-quarter moon that sent orange streaks rippling across an ebony surface of water.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The lake,” Sybelle exclaimed. “I’m sure he’s going the right way.” A fork appeared in the road and the driver turned onto the smaller, rougher path. The car crawled along the edge of the lake toward a luminous dot in the distance. The dot became the outline of a window on the second floor of a small wooden house set off the lake. The driver parked the taxi in front of the house and went to the door. A light winked on in the first floor and the door opened. Orient could see the driver talking to someone through the steamed windows, but all he could hear was the gentle rumble of the idling motor. The door shut and the light went out as the driver came back to the car. The return of the darkness was somehow comforting to Orient. The driver opened the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Bestmon?” he growled at Sybelle. “Bestmon "), _c('i', [_vm._v("Herr-gard.")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient told him in Swedish that Bestman Manor was correct.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You speak the language!” Sybelle was outraged. “You could have told him all the time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I just hope that we understood each other properly,” Orient said. “I don’t think he’s going to give us a second chance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If you speak Swedish, why didn’t you translate "), _c('i', [_vm._v("my ")]), _vm._v("directions for him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He speaks dialect,” Orient explained, closing his eyes. Twenty minutes later the taxi turned off the road into a grove of huge trees and continued along a high stone wall until they came to a gate. Before Orient could ask Sybelle, the driver guided the car through the open gate and headed for a group of lights back above a rolling, terraced lawn. The lights were part of a house which stood on the highest slope. The structure rose in jagged silhouette against the star-dusted sky as they approached.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Thank goodness.” Sybelle patted her hair and tried to see her reflection in the rear-view mirror. “Here we are. I can’t wait to have a hot brandy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver stopped at a door lit by an ornate overhanging lamp. Orient took the suitcases from the rack on the car and paid the driver while Sybelle ran ahead to the door. As he watched the lights of the cab recede, he began to entertain visions of an open fire and a snifter of cognac. When he joined Sybelle, however, he found that no one was answering the bell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Those lights are from Carl’s study,” she whispered in the stillness that crept in around them as the noise of the departing taxi faded into the shadows.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Try again.” His voice sounded unnaturally loud. He shivered in the damp wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The door opened and the slash of light released seemed to provide a sudden wave of warmth. A pointed, balding head peered turtlelike from around the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sybelle’s hand fluttered to her face. “Is Dr. Bestman at home?” she stammered in confusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The head receded and the door opened wider. A short man, who resembled a truculent reptile, stood at the threshold. His bullet head was supported by a thin, lined neck that moved back and forth between his narrow shoulders as he looked at them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Who are you please?” he asked in a voice much too deep for his size, suggesting that his chest was hollow to allow his head to retract. Even his nubby green suit seemed reptilian in pattern.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sybelle Lean and Dr. Orient,” she said, somewhat flustered. “Is Carl at home?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man stepped back from the door. “Come in, please. You’ve been expected. I’m Mr. Neilson, Dr. Bestman’s attorney.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient followed Sybelle inside a long wood-paneled hall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m sorry,” the little man began, “there’s been a change....”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A door opened at the end of the hall and a female voice called out. Orient looked up and saw a pale woman in a long black dress coming toward them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sybelle,” the woman called out. “I’m so glad you’re here.” A tall man followed her through the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“... you see Miss Lean, Carl Bestman was buried this morning,” Neilson was saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient heard something fall. The box had slipped out of Sybelle’s hands and spilled its contents on the carpet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The woman rushed up to embrace Sybelle. “Carl is dead,” she wailed softly. “Oh, Sybelle, he’s gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Orient looked at the man who came behind her. He was much taller than Neilson and his hard-set triangular face was set off by thick eyebrows that angled beneath the shock of white hair on his wide forehead.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The face seemed to separate from the man’s body and come crashing against Orient’s memory. He had seen it recently.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was the same looming face that had disturbed his meditative trance, weeks before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It happened two days ago,” the face was saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edbf078","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 78
// module chunks = 0